(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["autoclinic-contact-enquiry"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (customElements.get('autoclinic-contact-enquiry')) return;
  customElements.define('autoclinic-contact-enquiry', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.step = 0;
      this.form = this.querySelector('form');
      this.panels = Array.from(this.querySelectorAll('[data-step]'));
      this.back = this.querySelector('.acp-back');
      this.next = this.querySelector('.acp-next');
      this.back.addEventListener('click', () => this.showStep(Math.max(0, this.step - 1)));
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (this.step < 3 && this.validateStep(this.step)) this.showStep(this.step + 1);
      });
      this.form.addEventListener('input', (event) => {
        if (event.target.name === 'phone') event.target.setCustomValidity('');
      });
      this.form.addEventListener('change', (event) => {
        if (event.target.name !== 'category') return;
        const other = this.form.elements.other;
        const enabled = event.target.value === 'other';
        this.querySelector('[data-other-wrap]').hidden = !enabled;
        other.disabled = !enabled;
        other.required = enabled;
      });
      this.querySelector('[data-enhanced]').hidden = false;
      this.querySelectorAll('[data-channel]').forEach((link) => {
        link.addEventListener('click', (event) => {
          for (let step = 0; step < 3; step++) {
            this.showStep(step, false);
            if (!this.validateStep(step)) { event.preventDefault(); return; }
          }
          this.showStep(3, false);
        });
      });
    }
    validateStep(step) {
      const fields = this.panels[step].querySelectorAll('input:not(:disabled)');
      for (const field of fields) {
        if (field.type !== 'radio') field.value = field.value.trim();
        if (field.name === 'phone') {
          const digits = field.value.replace(/\D/g, '');
          const valid = /^[+\d\s()-]+$/.test(field.value) && digits.length >= 7 && digits.length <= 15;
          field.setCustomValidity(valid ? '' : this.dataset.phoneError);
        }
        if (!field.checkValidity()) { field.reportValidity(); return false; }
      }
      return true;
    }
    showStep(step, focus = true) {
      this.step = step;
      this.panels.forEach((panel, index) => { panel.hidden = index !== step; });
      this.back.hidden = step === 0;
      this.next.hidden = step === 3;
      this.querySelector('progress').value = step + 1;
      this.querySelector('[data-step-number]').textContent = step + 1;
      if (step === 3) this.buildEnquiry();
      if (focus) {
        const heading = this.panels[step].querySelector('h3');
        heading.focus({ preventScroll: true });
        heading.scrollIntoView({ block: 'center', behavior: 'auto' });
      }
    }
    buildEnquiry() {
      const fields = this.form.elements;
      const category = this.form.querySelector('input[name="category"]:checked');
      if (!category) return;
      const categoryText = category.dataset.title + (category.value === 'other' ? ': ' + fields.other.value.trim() : '');
      const rows = ['name', 'phone', 'email'].map((key) => [fields[key].dataset.label, fields[key].value.trim()]);
      rows.push([category.dataset.label, categoryText], [fields.car.dataset.label, fields.car.value.trim()]);
      const summary = this.querySelector('.acp-summary');
      summary.replaceChildren();
      rows.forEach(([label, value]) => {
        const term = document.createElement('dt');
        const detail = document.createElement('dd');
        term.textContent = label;
        detail.textContent = value;
        summary.append(term, detail);
      });
      const lines = [this.dataset.messageIntro, '', ...rows.map(([label, value]) => label + ': ' + value)];
      if (this.dataset.pageUrl) lines.push('', this.dataset.sourceLabel + ': ' + this.dataset.pageUrl);
      const message = lines.join('\n');
      this.querySelector('[data-channel="whatsapp"]').href = 'https://wa.me/' + this.dataset.whatsapp + '?text=' + encodeURIComponent(message);
      this.querySelector('[data-channel="email"]').href = 'mailto:' + this.dataset.email + '?subject=' + encodeURIComponent(this.dataset.subject) + '&body=' + encodeURIComponent(message);
    }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
